export const routes = {
  INDEX: '/:pickitCode?',
  TRACKING_INFO: '/tracking-info',
  TRACKING_LIVE_INFO: '/tracking-live',
};
